const weaponType = {
  PRIMARY: 0,
  SECONDARY: 1,
  MELEE: 2,
  EQUIPMENT: 3
};
module.exports = weaponType;